import { gql, useQuery } from "@apollo/client";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import React from "react";
import { Link } from "react-router-dom";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";
import { Loading } from "../../components/Loading";
import { googleMapStyle } from "../../MapStyle";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "reports", to: "#" },
  { text: "reports", to: "#" },
  { text: "delivery location", to: "/reports/delivery" },
];

const query_location = gql`
  query {
    merchantDeliveryLocation {
      lat
      lng
      rule
    }
  }
`;

export function DeliveryLocationScreen() {
  const { data, loading } = useQuery(query_location);

  if (data === undefined || loading) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <Loading />
      </Content>
    );
  }

  return (
    <div className="content-w">
      <ul className="breadcrumb" id="breadcrumb" style={{ margin: 0 }}>
        {BreadCrumbItems.map((item, index) => (
          <li key={index} className="breadcrumb-item">
            <Link to={item.to}>{item.text}</Link>
          </li>
        ))}
      </ul>
      <div className="content-i">
        <div
          className="content-box"
          style={{
            padding: 0,
            backgroundColor: "#f7fbff",
            // height: window.innerHeight - 55,
          }}
        >
          <div
            style={{
              width: "100%",
              height: window.innerHeight - 55 - 39,
              position: "absolute",
              overflow: "hidden",
            }}
          >
            <LoadScript googleMapsApiKey="AIzaSyBoMwlHxsNalkATrauFKfqqOtpZQCiBiVY">
              <GoogleMap
                mapContainerStyle={{
                  height: "100%",
                  width: "100%",
                  position: "absolute",
                }}
                zoom={7}
                center={{
                  lat: 11.9879665,
                  lng: 104.9806145,
                }}
                options={{
                  styles: googleMapStyle,
                }}
              >
                <MarkerClusterer
                  options={{
                    imagePath:
                      "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
                  }}
                >
                  {(clusterer) => {
                    return data.merchantDeliveryLocation.map(
                      (x: any, i: number) => {
                        return (
                          <Marker
                            position={{
                              lat: Number(x.lat),
                              lng: Number(x.lng),
                            }}
                            clusterer={clusterer}
                            key={i}
                          />
                        );
                      }
                    );
                  }}
                </MarkerClusterer>
              </GoogleMap>
            </LoadScript>
          </div>
        </div>
      </div>
    </div>
  );
}
